import React from "react";
import { IMenuGroup } from "../../@types/types";
import FeatherIcon from "feather-icons-react";
import { colors } from "../../utils";

interface GroupItemProps {
  item: IMenuGroup;
  index: number;
}

const GroupItem: React.FC<GroupItemProps> = ({ item, index }) => {
  return (
    <div className='menu-groups-item'>
      <div className='menu-groups-title'>
        {item.iconClass ? (
          <FeatherIcon
            icon={item.iconClass}
            height='24px'
            width='24px'
            style={{ color: colors[index] }}
          />
        ) : null}
        <span style={item.iconClass ? { marginLeft: "10px" } : {}}>
          {item.title}
        </span>
      </div>
      <div className='menu-groups-children'>
        {item.items.map((e) => {
          if (e.isVisible) {
            if (e.targetType === "BLANK") {
              return (
                <a
                  href={e.targetUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  key={e.id}
                >
                  {e.title}
                </a>
              );
            } else {
              return (
                <a href={e.targetUrl} key={e.id}>
                  {e.title}
                </a>
              );
            }
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default GroupItem;
